
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-choose-us",
      function () {
        return require("private-next-pages/why-choose-us.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-choose-us"])
      });
    }
  